export default "__VITE_ASSET__DhRjhNq6__"